// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        var list_amount_minor = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "list_amount_minor"), null));
        if (list_amount_minor.TAG === /* Ok */0) {
          var sale_amount_minor = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sale_amount_minor"), null));
          if (sale_amount_minor.TAG === /* Ok */0) {
            var currency_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency_code"), null));
            if (currency_code.TAG === /* Ok */0) {
              var is_active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
              if (is_active.TAG === /* Ok */0) {
                var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
                if (created_at.TAG === /* Ok */0) {
                  var updated_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
                  if (updated_at.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              code: code._0,
                              name: name._0,
                              description: description._0,
                              list_amount_minor: list_amount_minor._0,
                              sale_amount_minor: sale_amount_minor._0,
                              currency_code: currency_code._0,
                              is_active: is_active._0,
                              created_at: created_at._0,
                              updated_at: updated_at._0
                            }
                          };
                  }
                  var e = updated_at._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".updated_at" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = created_at._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".created_at" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = is_active._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".is_active" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = currency_code._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".currency_code" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = sale_amount_minor._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".sale_amount_minor" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = list_amount_minor._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".list_amount_minor" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function products_decode(v) {
  return Decco.arrayFromJson(t_decode, v);
}

export {
  t_decode ,
  products_decode ,
  
}
/* No side effect */
